var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValueList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "101.009,137.203 95.889,132.275 88.692,139.75 101.219,151.805 119.336,133.333 111.931,126.069  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 203.818,
    width: 72.487,
    height: 15.562
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.009,211.697 95.889,206.769 88.692,214.242 101.219,226.302 119.336,207.828 111.931,200.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.009,174.525 95.889,169.597 88.692,177.07 101.219,189.13 119.336,170.656 111.931,163.391  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 129.321,
    width: 72.487,
    height: 15.562
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 166.643,
    width: 72.487,
    height: 15.562
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.997,0C67.157,0,0,67.159,0,149.997C0,232.838,67.157,300,149.997,300S300,232.838,300,149.997 C299.997,67.159,232.838,0,149.997,0z M187.911,54.829L224.1,95.28h-36.189V54.829z M231.061,231.71h-0.002 c0,12.239-9.918,22.16-22.157,22.16h-119.1c-12.245,0-22.16-9.921-22.16-22.16V68.29c0-12.237,9.915-22.16,22.16-22.16h82.547 v64.708h58.712V231.71z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueList);
export default __webpack_public_path__ + "static/media/value-list.324118fe4a59b00fa74ae87391fda0de.svg";
export { ForwardRef as ReactComponent };